module.exports = "/_next/static/images/Hero@2x-d96addc05d091891a1c470db63a1728d.png";